export var partnerCodeMapper = function (data) {
    var partnerCodeEntity = {
        partnerCodeList: [],
    };
    if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
        data.map(function (record) {
            partnerCodeEntity.partnerCodeList.push({
                partnerId: record === null || record === void 0 ? void 0 : record.partnerid,
                partnerCode: record === null || record === void 0 ? void 0 : record.partner_code,
                upcId: record === null || record === void 0 ? void 0 : record.upcid,
                upcCode: record === null || record === void 0 ? void 0 : record.upccode,
                partnerName: record === null || record === void 0 ? void 0 : record.partner_name,
                partnerType: record === null || record === void 0 ? void 0 : record.partner_type,
                empCode: record === null || record === void 0 ? void 0 : record.emp_code,
                empId: record === null || record === void 0 ? void 0 : record.emp_id,
                isDefault: record === null || record === void 0 ? void 0 : record.isDefault,
            });
        });
    }
    return partnerCodeEntity;
};
